import { Component, EventEmitter, Output } from '@angular/core';
import { CommonFeatureInterface } from 'src/app/model/commonFeature/common-feature-interface';
import { CommonFeatureService } from 'src/app/services/common-feature-service/common-feature.service';
import { LinkingMethod } from 'src/app/model/enums/linkingMethod';

@Component({
    selector: 'app-common-feature-add',
    templateUrl: './common-feature-add.component.html',
    styleUrls: ['./common-feature-add.component.css'],
    standalone: false
})
export class CommonFeatureAddComponent {
    @Output()
    public addedFeature = new EventEmitter<CommonFeatureInterface>();

    public showNewFeature: boolean = false;
    commonFeature: CommonFeatureInterface;

    constructor(private commonFeatureService: CommonFeatureService) {
        this.resetCommonFeaturePlaceholder();
    }

    /* Toggles the Frontend Form to add a Feature */
    public toggleNewFeatureForm(): void {
        this.showNewFeature = !this.showNewFeature;
    }

    private resetCommonFeaturePlaceholder(): void {
        this.commonFeature = {
            id: null,
            name: '',
            filterOption: false,
            featureEntries: [],
            showDetailPage: false,
            linkingMethod: LinkingMethod.AND,
            position: 1000,
            categories: []
        };
    }

    /* Takes the Form Values and calls the Service to create a new Feature with that Values */
    private addNewFeature(): void {
        this.commonFeatureService
            .addNewFeature(
                this.commonFeature.name,
                this.commonFeature.filterOption,
                this.commonFeature.featureEntries.map((entry) => entry.name),
                this.commonFeature.showDetailPage,
                this.commonFeature.linkingMethod,
                this.commonFeature.categories
            )
            .subscribe(
                (success) => {
                    this.addedFeature.emit(success);
                },
                () => {}
            );
    }

    onCloseEdit(result: 'ABORT' | 'SAVE' | 'DELETE'): void {
        switch (result) {
            case 'SAVE': {
                this.addNewFeature();
                break;
            }
        }
        this.toggleNewFeatureForm();
        this.resetCommonFeaturePlaceholder();
    }
}
